import type { ObjectDirective } from 'vue'

type EditState = { value: unknown; blank: boolean; focus: () => void; input: (event: Event) => void; blur: () => void }
const states = new WeakMap<HTMLInputElement, EditState>()

// Clearing on focus is visual only. An empty edit never reaches v-model or autosave.
export const replaceNumber: ObjectDirective<HTMLInputElement, unknown> = {
  mounted(element, binding) {
    const state: EditState = {
      value: binding.value,
      blank: false,
      focus() { state.blank = true; element.value = '' },
      input(event) {
        state.blank = element.value === ''
        if (state.blank) event.stopImmediatePropagation()
      },
      blur() { state.blank = false; element.value = String(state.value ?? '') },
    }
    states.set(element, state)
    element.addEventListener('focus', state.focus)
    element.addEventListener('input', state.input, true)
    element.addEventListener('blur', state.blur)
  },
  updated(element, binding) {
    const state = states.get(element)
    if (!state) return
    state.value = binding.value
    if (state.blank && document.activeElement === element) element.value = ''
  },
  unmounted(element) {
    const state = states.get(element)
    if (!state) return
    element.removeEventListener('focus', state.focus)
    element.removeEventListener('input', state.input, true)
    element.removeEventListener('blur', state.blur)
    states.delete(element)
  },
}
